
import { Component, Vue } from 'vue-property-decorator';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import OsGlobalDialogs from '@/components/app/OsGlobalDialogs.vue';
@Component({
  components: { OsGlobalDialogs, OsSheetContent, OsSheet }
})
export default class SurveyLayout extends Vue {}
